import type { AxiosResponse } from "axios";
import type { HttpClient } from "@/services/baseClient";
import type {
  ApiResponse,
  Device,
  UpdateDeviceRequest,
  Driver,
  DriverList,
  DriverDetails,
  DashboardData,
} from "@/types";

export function createDevicesApi({ client }: HttpClient) {
  return {
    async getDevicesByUser(userId: string): Promise<Device[]> {
      const response: AxiosResponse<ApiResponse<Device[]>> =
        await client.get(`/devices/user/${userId}`);
      return response.data.data;
    },

    async updateDevice(
      id: string,
      data: UpdateDeviceRequest,
    ): Promise<Device> {
      const response: AxiosResponse<ApiResponse<Device>> =
        await client.put(`/devices/${id}`, data);
      return response.data.data;
    },

    async deleteDevice(id: string): Promise<void> {
      await client.delete(`/devices/${id}`);
    },

    async unlinkDevice(id: string): Promise<void> {
      await client.post(`/devices/${id}/unlink`);
    },

    async getDrivers(): Promise<DriverList> {
      const response: AxiosResponse<
        ApiResponse<Driver[]> & {
          publicCount?: number;
          totalCount?: number;
        }
      > = await client.get("/users");
      const drivers = response.data.data;
      return {
        drivers,
        publicCount: response.data.publicCount ?? drivers.length,
        totalCount: response.data.totalCount ?? drivers.length,
      };
    },

    async getDriver(id: string): Promise<DriverDetails> {
      const response: AxiosResponse<ApiResponse<DriverDetails>> =
        await client.get(`/users/${id}`);
      return response.data.data;
    },

    async getDashboard(): Promise<DashboardData> {
      const response: AxiosResponse<ApiResponse<DashboardData>> =
        await client.get("/dashboard");
      return response.data.data;
    },
  };
}
